(() => {
  const cleanups = new WeakMap();
  const desktop = matchMedia('(min-width: 48.0625rem)');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (cleanups.has(root)) return;
    const cards = [...root.querySelectorAll('.dra-ana-role-card[data-role-index]')];
    const images = [...root.querySelectorAll('.dra-ana-role-image[data-role-index]')];
    if (!cards.length || cards.length !== images.length) return;

    let observer;
    let activeIndex;
    let animationFrame = null;
    const setActive = (index) => {
      if (index === activeIndex) return;
      activeIndex = index;
      root.dataset.activeRole = String(index);
      cards.forEach((card) => card.classList.toggle('is-active', Number(card.dataset.roleIndex) === index));
      images.forEach((image) => image.classList.toggle('is-active', Number(image.dataset.roleIndex) === index));
    };

    const updateActive = () => {
      const viewportCenter = window.innerHeight / 2;
      const closest = cards.reduce((current, card) => {
        const currentRect = current.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const currentDistance = Math.abs(currentRect.top + currentRect.height / 2 - viewportCenter);
        const cardDistance = Math.abs(cardRect.top + cardRect.height / 2 - viewportCenter);
        return cardDistance < currentDistance ? card : current;
      });
      setActive(Number(closest.dataset.roleIndex));
    };
    const scheduleActiveUpdate = () => {
      if (animationFrame !== null) return;
      animationFrame = requestAnimationFrame(() => {
        animationFrame = null;
        updateActive();
      });
    };
    const stop = () => {
      observer?.disconnect();
      observer = undefined;
      if (animationFrame !== null) cancelAnimationFrame(animationFrame);
      animationFrame = null;
      window.removeEventListener('scroll', scheduleActiveUpdate);
      window.removeEventListener('resize', scheduleActiveUpdate);
    };
    const start = () => {
      stop();
      if (!desktop.matches || reducedMotion.matches || !('IntersectionObserver' in window)) {
        setActive(0);
        return;
      }
      observer = new IntersectionObserver(
        scheduleActiveUpdate,
        { rootMargin: '-42% 0px -42% 0px', threshold: 0 },
      );
      cards.forEach((card) => observer.observe(card));
      window.addEventListener('scroll', scheduleActiveUpdate, { passive: true });
      window.addEventListener('resize', scheduleActiveUpdate);
      updateActive();
    };

    desktop.addEventListener('change', start);
    reducedMotion.addEventListener('change', start);
    start();
    cleanups.set(root, () => {
      stop();
      desktop.removeEventListener('change', start);
      reducedMotion.removeEventListener('change', start);
      cleanups.delete(root);
    });
  }

  const rootsIn = (scope) => [
    ...(scope.matches?.('[data-dra-roles]') ? [scope] : []),
    ...scope.querySelectorAll('[data-dra-roles]'),
  ];
  const initScope = (scope = document) => rootsIn(scope).forEach(init);
  const cleanupScope = (scope) => rootsIn(scope).forEach((root) => cleanups.get(root)?.());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initScope(), { once: true }); else initScope();
  document.addEventListener('shopify:section:load', (event) => initScope(event.target));
  document.addEventListener('shopify:section:unload', (event) => cleanupScope(event.target));
})();
